var React = require('react');
var Sliderr = require('react-slick');

var NextArrow = React.createClass({
  render: function() {
    return <div {...this.props} className="slider-control right-slider-control "  href="#myCarousel" data-slide=""><span className="glyphicon glyphicon-chevron-right"></span></div>
  }
});
//return <span className="right carousel-control"  data-slide="next"><span className="glyphicon glyphicon-chevron-right"></span></span>
//return <span className="left carousel-control"  data-slide="prev"><span className="glyphicon glyphicon-chevron-left"></span></span>
var PrevArrow = React.createClass({
  render: function() {
    return (
      <div {...this.props} className="slider-control left-slider-control" href="#myCarousel"  data-slide=""><span className="glyphicon glyphicon-chevron-left"></span></div>
    );
  }
});

var SimpleSlider = React.createClass({
  render: function () {
    var settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      waitForAnimate: true,
      fade:true,
      lazyLoad:false,
      draggable:false,
      focusOnSelect:true,
      autoplay: true,
      autoplaySpeed: 5000,
      useCSS:true,
      pauseOnHover: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />
    };
    return (<div id="myCarousel" className="carousel slide slider-container" data-ride="carousel">
      <Sliderr {...settings}>
        <img className='img-slide' src="img/slider/test/1.jpg" alt="First slide"/>
        <img className='img-slide' src="img/slider/test/2.jpg" data-src="" alt="Second slide"/>
        <img className='img-slide' src="img/slider/test/3.jpg" data-src="" alt="Fourth slide"/>
        <img className='img-slide' src="img/slider/test/4.jpg" data-src="" alt="Fifth slide"/>
      </Sliderr>
    </div>
    );
  }

});

module.exports=SimpleSlider



/** WEBPACK FOOTER **
 ** ./modules/components/App/Slider.js
 **/